module.exports = __webpack_public_path__ + "static/media/aviator_banner.fdf8f466.png";